var _style, _circle, _path, _path2, _path3;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIconReactionAngry = function SvgIconReactionAngry(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#102236;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 30,
    y1: 60,
    x2: 30,
    y2: -9.094947e-13
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDE6E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF4C41"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 30,
    cy: 30,
    r: 30
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.8,31c-0.4-0.7-1.3-0.8-1.9-0.4c0,0-3.4,2.2-7.9,3.1c-4.6,0.9-8.1,0.5-8.2,0.5c-0.8-0.1-1.5,0.5-1.6,1.2 c-0.1,0.8,0.5,1.5,1.2,1.6c0.1,0,0.9,0.1,2.3,0.1c0.9,0,2,0,3.2-0.2c0,0.2-0.1,0.4-0.1,0.6c0,1.8,1.4,3.2,3.2,3.2 c1.8,0,3.2-1.4,3.2-3.2c0-0.6-0.2-1.2-0.5-1.7c3.8-1.1,6.4-2.8,6.6-2.9C53.1,32.5,53.2,31.6,52.8,31z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.2,31c0.4-0.7,1.3-0.8,1.9-0.4c0,0,3.4,2.2,7.9,3.1c4.6,0.9,8.1,0.5,8.2,0.5c0.8-0.1,1.5,0.5,1.6,1.2 c0.1,0.8-0.5,1.5-1.2,1.6c-0.1,0-0.9,0.1-2.3,0.1c-0.9,0-2,0-3.2-0.2c0,0.2,0.1,0.4,0.1,0.6c0,1.8-1.4,3.2-3.2,3.2 c-1.8,0-3.2-1.4-3.2-3.2c0-0.6,0.2-1.2,0.5-1.7c-3.8-1.1-6.4-2.8-6.6-2.9C6.9,32.5,6.8,31.6,7.2,31z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.6,48.1c0,1.3-4.5,1.5-9.8,1.5c-5.3,0-9.3-0.3-9.3-1.5c0-1.3,4.3-2.3,9.5-2.3 C35.3,45.8,39.6,46.8,39.6,48.1z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconReactionAngry, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_reaction_angry.a936dcdd.svg";
export { ForwardRef as ReactComponent };